import { ChangeEvent } from "react";

import { Client } from "@/Common/Api/Client";
import { OffendingAgent } from "@/Common/Api/MedfarDictionaries/Dto/Responses/OffendingAgent";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import * as ServerOperations from "@/Common/Operations/operations.server";

interface IOffendingAgentSearchAutocomplete {
    onItemSelectCallback: (item: OffendingAgent) => void;
    onBlurCallback?: (text: string) => void;
    debounce: number;
    dataCy?: string;
    newValue: string;
    valid?: boolean;
}

class OffendingAgentSearchAutocompleteState {
    public ForceHideList: boolean;
    public sNewValueEventId: string;
    public text: string;
    public list: Immutable.List<OffendingAgent>;

    constructor(s: OffendingAgentSearchAutocompleteState) {
        if (s != null) {
            this.text = s.text;
            this.ForceHideList = s.ForceHideList;
            this.list = s.list;
        }
        else {
            this.ForceHideList = false;
            this.text = "";
            this.list = Immutable.List([]);
        }
    }
}

class OffendingAgentSearchAutocomplete extends React.Component<IOffendingAgentSearchAutocomplete, OffendingAgentSearchAutocompleteState> {
    private timeoutReference: number;
    private cancelOnBlur: boolean = false;

    public render(): JSX.Element {
        return (
            <div className="fmp-autocomplete" onBlur={this.onBlur.bind(this)} tabIndex={0}>
                <input
                    id="__offendingAgentSearchField"
                    data-cy={this.props.dataCy}
                    onKeyDown={this.inputKeyDown.bind(this)}
                    type="text"
                    onChange={this.onTextChange.bind(this)}
                    value={this.state.text}
                    className={this.props.valid === false ? "form-control invalid" : "form-control"}
                />
                {this.state.list.size > 0 && !this.state.ForceHideList && (
                    <div className="list-container-txtbox">
                        <div className="results-container" style={{ width: "301px" }} onMouseEnter={this.onMouseEnter.bind(this)} onMouseLeave={this.onMouseExit.bind(this)}>
                            <ul className="results-list">
                                {this.state.list.map((item: OffendingAgent, i: number) => {
                                    var hyperlink = item.Active == true ?
                                        (<a style={{ background: "lightblue" }}>{item.OffendingAgentName} ({item.ActiveIngredientName})</a>)
                                        : (<a>{item.OffendingAgentName} ({item.ActiveIngredientName})</a>);

                                    return (
                                        <li key={i + "__code_"}>
                                            <div onMouseDown={this.selectItem.bind(this, item)} data-cy={this.props.dataCy ? `${this.props.dataCy}-${i}` : null}>
                                                {hyperlink}
                                            </div>

                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    public componentWillMount(): void {
        this.timeoutReference = -1;
        var s = new OffendingAgentSearchAutocompleteState(this.state);
        s.ForceHideList = false;
        s.text = this.props.newValue;
        s.list = Immutable.List([]);
        this.setState(s);
    }

    public componentWillReceiveProps(nextProps: IOffendingAgentSearchAutocomplete): void {
        var s = new OffendingAgentSearchAutocompleteState(this.state);
        s.text = nextProps.newValue;
        this.setState(s);
    }

    public componentDidMount(): void {
        window.setTimeout(() => $("#__offendingAgentSearchField").focus(), 50);
    }

    public shouldComponentUpdate(): boolean {
        return true;
    }

    private onTextChange(e: ChangeEvent<HTMLInputElement>): void {
        var val = e.target.value;
        var s = new OffendingAgentSearchAutocompleteState(this.state);
        s.ForceHideList = val == "" ? true : false;
        s.text = val;
        this.setState(s);

        if (this.timeoutReference !== -1) {
            clearTimeout(this.timeoutReference);
            this.timeoutReference = -1;
        }

        if (val != "") {
            var self = this;
            self.loadData(val);
        }
    }

    private forceHideDelayedList(): void {
        var self = this;

        this.timeoutReference = window.setTimeout(() => {
            self.forceHideList();
        }, 10);
    }

    private forceHideList(Hide: boolean = true): void {
        var s = new OffendingAgentSearchAutocompleteState(this.state);
        s.ForceHideList = Hide;
        this.setState(s);
    }

    private inputKeyDown(e: React.KeyboardEvent): void {
        // up
        if (e.keyCode === 38) { e.preventDefault(); this.MoveSelectionUpOrDown(true); }

        // down
        if (e.keyCode === 40) { e.preventDefault(); this.MoveSelectionUpOrDown(false); }

        // enter
        if (e.keyCode === 13) {
            this.forceHideDelayedList();
            this.addSeletedItem();
        }

        // tab
        if (e.keyCode === 9) {
            this.forceHideDelayedList();
            this.addSeletedItem();
        }

        // escape
        if (e.keyCode === 27) {
            this.forceHideList();
        }
    }

    // keyboard triggered
    private MoveSelectionUpOrDown(IsDirectionUp: boolean): void {
        var collection = this.state.list.toArray();
        if (collection.length == 0)
            return;

        var idx = this.indexOfSelectedItem();
        if (idx === -1) {
            collection.forEach(x => x.Active = false);
            collection[IsDirectionUp ? collection.length - 1 : 0].Active = true;
            this.updateStateWithNewList(collection, false);
            return;
        }

        if ((idx === 0 && IsDirectionUp) || (idx === collection.length - 1 && !IsDirectionUp)) {
            collection[IsDirectionUp ? 0 : collection.length - 1].Active = false;
            this.updateStateWithNewList(collection, true);
            return;
        }

        collection[idx].Active = false;
        idx = idx + (IsDirectionUp ? -1 : 1);

        collection[idx].Active = true;
        this.updateStateWithNewList(collection, false);
    }

    private indexOfSelectedItem(): number {
        if (this.state.list.count() === 0)
            return -1;

        for (var i = 0; i < this.state.list.count(); i++) {
            var item = this.state.list.toArray()[i];
            if (item.Active == true) {
                return i;
            }
        }
        return -1;
    }

    private updateStateWithNewList(list: OffendingAgent[], forceHide: boolean): void {
        var state = new OffendingAgentSearchAutocompleteState(this.state);
        state.ForceHideList = forceHide;
        state.list = Immutable.List(list);
        this.setState(state);
    }

    private addSeletedItem(): void {
        var item = this.state.list.filter(x => x.Active == true).toArray();
        if (item.length > 0) {
            this.selectItem(item[0]);
        }
        else
            this.selectItem(null);
    }

    private loadData(text: string, NoDebounce: boolean = false): void {
        var self = this;
        this.timeoutReference = window.setTimeout(() => {
            self.loadDataRaw(text);
        }, NoDebounce ? 50 : this.props.debounce);
    }

    private loadDataRaw(text: string): void {
        if (text.trim().length < 2) return;
        var self = this;
        var client = new Client();
        var path = apiSettings.buildApiPath();

        client.Post(
            path,
            ServerOperations.Server.MedfarDictionnary_SearchOffendingAgents,
            { SearchString: text },
            response => {
                var model: OffendingAgent[] = response.OffendingAgents;

                var s = new OffendingAgentSearchAutocompleteState(this.state);
                s.list = Immutable.List(model);
                self.setState(s);
            },
            error => {
                console.error(error);
            }
        );
    }

    public selectItem(item: OffendingAgent): void {
        this.cancelOnBlur = true;

        var s = new OffendingAgentSearchAutocompleteState(this.state);
        s.list = Immutable.List([]);

        if (item != null)
            s.text = item.OffendingAgentName;
        else {
            item = new OffendingAgent();
            item.Id = GuidHelper.NewGuid();
            item.OffendingAgentName = s.text;
        }

        var self = this;

        this.setState(
            s,
            () => {
            // wait until state has been set to call parent select item callback
                self.props.onItemSelectCallback(item);

                window.setTimeout(() => self.cancelOnBlur = false, 400);
            }
        );
    }

    private onBlur(): void {
        var self = this;
        if (this.props.onBlurCallback != null) {
            window.setTimeout(
                () => {
                    if (!this.cancelOnBlur) {
                        var s = new OffendingAgentSearchAutocompleteState(this.state);
                        s.list = Immutable.List([]);
                        s.ForceHideList = true;
                        this.setState(s, () => self.props.onBlurCallback(self.state.text));
                    }
                },
                100
            );
        }
    }

    private onMouseEnter(): void {
        this.cancelOnBlur = true;
    }

    private onMouseExit(): void {
        this.cancelOnBlur = false;
    }
}

export { OffendingAgentSearchAutocomplete };
